<h2 mat-dialog-title>{{ labels.TITLE }}</h2>
<mat-dialog-content>
  <form [formGroup]="errorReportForm">
    <mat-label>{{ labels.WHERE_ERROR }}</mat-label>
    <div class="error-location-buttons sub-options">
      <button
        mat-button
        (click)="selectErrorLocation('IA')"
        [class.selected]="errorLocation === 'IA'"
      >
        {{ labels.IA }}
      </button>
      <button
        mat-button
        (click)="selectErrorLocation('PLATFORM')"
        [class.selected]="errorLocation === 'PLATFORM'"
      >
        {{ labels.PLATFORM }}
      </button>
      <button
        mat-button
        (click)="selectErrorLocation('OTHER')"
        [class.selected]="errorLocation === 'OTHER'"
      >
        {{ labels.OTHER }}
      </button>
    </div>
    <hr />
    <div *ngIf="errorLocation === 'IA'" class="sub-options">
      <button
        mat-button
        (click)="selectSubOption('ANALYSIS')"
        [class.selected]="subOption === 'ANALYSIS'"
      >
        {{ labels.ANALYSIS }}
      </button>
      <button
        mat-button
        (click)="selectSubOption('HEATMAP')"
        [class.selected]="subOption === 'HEATMAP'"
      >
        {{ labels.HEATMAP }}
      </button>
      <button
        mat-button
        (click)="selectSubOption('OTHER')"
        [class.selected]="subOption === 'OTHER'"
      >
        {{ labels.OTHER }}
      </button>
    </div>
    <div *ngIf="errorLocation === 'PLATFORM'" class="sub-options">
      <button
        mat-button
        (click)="selectSubOption('DIGITAL_MICROSCOPE')"
        [class.selected]="subOption === 'DIGITAL_MICROSCOPE'"
      >
        {{ labels.DIGITAL_MICROSCOPE }}
      </button>
      <button
        mat-button
        (click)="selectSubOption('REPORT')"
        [class.selected]="subOption === 'REPORT'"
      >
        {{ labels.REPORT }}
      </button>
      <button
        mat-button
        (click)="selectSubOption('DISCUSSION')"
        [class.selected]="subOption === 'DISCUSSION'"
      >
        {{ labels.DISCUSSION }}
      </button>
      <button
        mat-button
        (click)="selectSubOption('DIGITAL_DATABASE')"
        [class.selected]="subOption === 'DIGITAL_DATABASE'"
      >
        {{ labels.DIGITAL_DATABASE }}
      </button>
      <button
        mat-button
        (click)="selectSubOption('OTHER')"
        [class.selected]="subOption === 'OTHER'"
      >
        {{ labels.OTHER }}
      </button>
    </div>
    <hr *ngIf="subOption === 'ANALYSIS' || subOption === 'HEATMAP'" />
    <div
      *ngIf="subOption === 'ANALYSIS' || subOption === 'HEATMAP'"
      class="sub-options"
    >
      <button
        mat-button
        (click)="selectSubOption2('INCORRECT_RESULT')"
        [class.selected]="subOption2 === 'INCORRECT_RESULT'"
      >
        {{ labels.INCORRECT_RESULT }}
      </button>
      <button
        mat-button
        (click)="selectSubOption2('EXECUTION')"
        [class.selected]="subOption2 === 'EXECUTION'"
      >
        {{ labels.EXECUTION }}
      </button>
    </div>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ labels.DESCRIPTION }}</mat-label>
      <textarea
        matInput
        formControlName="error_message"
        rows="5"
        (blur)="onTextareaInteraction()"
        (input)="onTextareaInteraction()"
        [attr.readonly]="true"
        style="resize: none"
      ></textarea>
      <mat-error
        *ngIf="
          errorReportForm.get('error_message')?.hasError('required') &&
          textareaInteracted
        "
      >
        {{ labels.ERROR_DESCRIPTION_REQUIRED }}
      </mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">
    {{ labels.CANCEL }}
  </button>
  <button
    mat-button
    class="submit"
    (click)="onSubmit()"
    [disabled]="!errorReportForm.valid || !errorLocation"
  >
    {{ labels.SUBMIT }}
  </button>
</mat-dialog-actions>
